module.exports = __webpack_public_path__ + "static/media/2022-normalized.09a142a6.csv";